/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Today_TitleInputs */

const en_directory_vibebids_today_title = /** @type {(inputs: Directory_Vibebids_Today_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today's top ranking`)
};

const zh_directory_vibebids_today_title = /** @type {(inputs: Directory_Vibebids_Today_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日排名`)
};

/**
* | output |
* | --- |
* | "Today's top ranking" |
*
* @param {Directory_Vibebids_Today_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_today_title = /** @type {((inputs?: Directory_Vibebids_Today_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Today_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_today_title(inputs)
	return zh_directory_vibebids_today_title(inputs)
});
export { directory_vibebids_today_title as "directory.vibebids.today_title" }